module.exports = "/_next/static/images/bg-info-extend-2-b8980559.png";